import { CoordinatorService } from './coordinator.service';
import { Field } from './field';
import { SEARCH_HELP, SEARCH_ITEM_HELP_DATA } from './search-archive$';
import { XItem } from './x-item';

const fieldTagLs = [
    'text',
    'title',
    'abstract',
    'source',
    'year',
    'authorLs',
    'author-first',
    'author-last',
    'applicant',
    'langLs',
    'doi',
    'id',
    'cutoff',
];

export class Field$ {
    cutoff: number = 0;

    private _fieldCollectionMap = new Map<string, Field>();
    private _fieldPreviewMap = new Map<string, Field>();
    private _idSet?: Set<string>;

    constructor(private coords: CoordinatorService) {
        this.clear();
    }

    clear() {
        this._fieldCollectionMap.clear();
        this._fieldPreviewMap.clear();
        fieldTagLs.forEach((tag) => {
            this._fieldCollectionMap.set(tag, new Field(this.coords, tag));
            this._fieldPreviewMap.set(tag, new Field(this.coords, tag, true));
        });
    }

    stageChange() {
        this.run();
    }

    get isActive() {
        return this._idSet !== undefined;
    }
    process(ls: XItem[]) {
        if (!this.isActive) return ls;
        return ls.filter((xitm) => this._idSet!.has(xitm.id));
    }

    run() {
        let s: Set<string>;
        this.fieldLs().forEach((field) => {
            if (field.isActive) {
                if (s === undefined) {
                    s = new Set<string>(field.idSet);
                } else {
                    for (const id of s) {
                        if (!field.idSet!.has(id)) s.delete(id);
                    }
                }
            }
        });
        this._idSet = s!;
        this.coords.resultList$.markForCheck();
    }

    save(ls: string[]) {
        if (!this.isActive) return;
        ls.push(`const fieldBoard = searchInterface.widget('field-board')`);
        this.fieldLs().forEach((field) => field.save(ls));
    }

    saveRun(ls: string[]) {
        if (!this.isActive) return;
        this.fieldLs().forEach((field) => field.saveRun(ls));
    }

    saveHelp(resp: SEARCH_HELP) {
        resp.fieldLs = this.fieldLs()
            .map((field) => field.saveHelp())
            .filter((x) => x) as SEARCH_ITEM_HELP_DATA[];
    }

    clearButtonAction() {
        this.fieldLs().forEach((field) => field.clear());
        this.run();
    }

    fieldLs(isAll = false) {
        const mp = this.coords.stage$.isPreview ? this._fieldPreviewMap : this._fieldCollectionMap;
        const ls = Array.from(mp.values());
        let respLs = isAll ? ls : ls.filter((x) => x.isVisible);
        if (!respLs.length) {
            ls[0].isVisible = true;
            return [ls[0]];
        }
        return respLs;
    }

    get(tag: string) {
        const mp = this.coords.stage$.isPreview ? this._fieldPreviewMap : this._fieldCollectionMap;
        return mp.get(tag);
    }
}
